import { createRootRoute, Outlet } from '@tanstack/react-router'
import { AuthProvider } from '@/common/hooks/useAuth'
import { ImpersonationProvider } from '@/common/hooks/useImpersonation'
import { MockTimeBanner } from '@/common/components/mock-time-banner/MockTimeBanner'
import { ImpersonationBanner } from '@/common/components/impersonation-banner/ImpersonationBanner'
import { Tooltip } from '@/common/components/tooltip'

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  return (
    <AuthProvider>
      <ImpersonationProvider>
        <Tooltip.Provider delayDuration={300}>
          <MockTimeBanner />
          <ImpersonationBanner />
          <Outlet />
        </Tooltip.Provider>
      </ImpersonationProvider>
    </AuthProvider>
  )
}
